export const LOADING_TEXT_SENDING = 'Vteřinku, odesíláme data';
export const LOADING_TEXT_COMPUTING = 'Vteřinku, počítáme vaši rekonstrukci';
